var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.65ad581d050ec8d909c76faf21a06c23.svg#p';
                    var viewUrl = 'sprites.65ad581d050ec8d909c76faf21a06c23.svg#view-p';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 21 21',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };